import { gsePricingApi } from 'app/services/api';

import { createNamedActions } from 'utils/namedActionTypesProxy';

import { extractErrorMessage } from '../marginCenter.actionUtils';

export const PROGRAM_CATALOG_ACTION_TYPE = createNamedActions('marginCenter/programCatalog', {
  SET_PROGRAM_CATALOG_LOADING: 'SET_PROGRAM_CATALOG_LOADING',
  GET_PROGRAM_CATALOG: 'GET_PROGRAM_CATALOG',
  SET_PROGRAM_CATALOG_ERROR: 'SET_PROGRAM_CATALOG_ERROR',
});

// The Freddie source-product catalog behind the program editor's Execution Sources
// picker — compute-on-read from the company's compiled ExecutionLattice, enriched with the
// internal programs already mapped to each product (GET gse-pricing/program-catalog). An empty
// array is a legitimate response (no live pull yet / feed not connected), never an error state.
export const getProgramCatalogAction =
  ({ seller } = {}) =>
  async dispatch => {
    dispatch({ type: PROGRAM_CATALOG_ACTION_TYPE.SET_PROGRAM_CATALOG_LOADING, payload: true });

    try {
      const { data } = await gsePricingApi.getProgramCatalog({ seller });

      return dispatch({
        type: PROGRAM_CATALOG_ACTION_TYPE.GET_PROGRAM_CATALOG,
        payload: data ?? [],
      });
    } catch (error) {
      return dispatch({
        type: PROGRAM_CATALOG_ACTION_TYPE.SET_PROGRAM_CATALOG_ERROR,
        payload: extractErrorMessage(error),
      });
    }
  };
